{
  "version": 1,
  "asset_id": "ced300c1-e516-4435-b807-d382d0bd68e9",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/ced300c1-e516-4435-b807-d382d0bd68e9/floral-city-black-shingle-roof-installation-480w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/ced300c1-e516-4435-b807-d382d0bd68e9/floral-city-black-shingle-roof-installation-480w.avif",
  "original_filename": "floral-city-black-shingle-roof-installation-480w.avif",
  "size": 13587,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
